/**
 * Utilies revolving around the browser.
 *
 * File: \src\components\general\util\BrowserUtil.ts
 * Created Date: Thursday, April 4th 2019, 16:36:08
 * Author: Sascha Herrmann
 * -----
 * Last Modified: February 9th 2021, 12:18:04
 * Modified By: Sascha Herrmann
 * -----
 * Copyright (c) 2017-2019 Liebherr-Hausgeräte GmbH
 */

import Bowser from 'bowser';

/**
 * BrowserUtil class.
 *
 * @export
 * @class BrowserUtil
 */
export default class BrowserUtil {
  /**
   * Checks the current browser and returns true if it is the new Edge.
   *
   * @static
   * @returns {boolean} true if it's the new Edge.
   * @memberof BrowserUtil
   */
  public static isEdge(): boolean {
    const browser = Bowser.getParser(window.navigator.userAgent);

    return browser.getBrowserName() === 'Microsoft Edge' && /edg(a|ios)*/i.test(window.navigator.userAgent);
  }

  /**
   * Checks the current browser and returns true if it is Chrome.
   *
   * @static
   * @returns {boolean} true if it's Chrome.
   * @memberof BrowserUtil
   */
  public static isChrome(): boolean {
    const browser = Bowser.getParser(window.navigator.userAgent);

    return browser.getBrowserName() === 'Chrome';
  }

  /**
   * Checks the current browser and returns true if it is Firefox.
   *
   * @static
   * @returns {boolean} true if it's Firefox.
   * @memberof BrowserUtil
   */
  public static isFirefox(): boolean {
    const browser = Bowser.getParser(window.navigator.userAgent);

    return browser.getBrowserName() === 'Firefox';
  }

  /**
   * Checks the current browser and returns true if it is IE.
   *
   * @static
   * @returns {boolean} true if it's IE.
   * @memberof BrowserUtil
   */
  public static isIE(): boolean {
    const browser = Bowser.getParser(window.navigator.userAgent);

    return browser.getBrowserName() === 'Internet Explorer';
  }

  /**
   * Checks the current browser and returns true if it is Safari
   *
   * @static
   * @returns {boolean}
   * @memberof BrowserUtil
   */
  public static isSafari(): boolean {
    const browser = Bowser.getParser(window.navigator.userAgent);

    return browser.getBrowserName() === 'Safari';
  }

  /**
   * Checks if this browser is a supported one (Chrome, Firefox, Safari new and old Edge).
   *
   * @static
   * @returns true if the browser is supported.
   *
   * @memberof BrowserUtil
   */
  public static isSupportedBrowser() {
    return BrowserUtil.isChrome() || BrowserUtil.isFirefox() || BrowserUtil.isEdge() || BrowserUtil.isSafari();
  }
}
